/**
 * Converts a form field name into a valid HTML ID.
 * @param name - Form field name to convert
 * @returns Sanitized ID string
 * @example idFromName('user[email]') // 'user_email'
 */
var idFromName = function idFromName(name) {
  return name.replace(/\]/g, '').replace(/[^-a-zA-Z0-9:.]/g, '_');
};

/**
 * Computes ID: explicit `id` prop → legacy `idFromName(name)`
 * @param idProp - Optional explicit ID override
 * @param baseId - Base ID from `idFromName(name)`
 * @returns Computed ID string
 * @example computeId('custom-id', 'user-name') // 'custom-id'
 */
var computeId = function computeId(idProp, baseId) {
  return idProp !== null && idProp !== void 0 ? idProp : baseId;
};

export { computeId, idFromName };
//# sourceMappingURL=html.js.map
